import { ClientApi } from 'pos-client';
import config from '@/config';

const { apiKey, secret, baseUrl, deviceId, osTicketUrl } = config;

class Api {
  _clientPos = null;

  constructor() {
    this._url = baseUrl;
    this._apiKey = apiKey;
    this._secret = secret;
    this._deviceId = deviceId;
    this._token = null;
  }

  _buildToken() {
    return `${this._token}`;
  }

  async init() {
    this._clientPos.getConfig();
  }

  getAPiOsTicket() {
    return this.createPostClientInstance(osTicketUrl);
  }

  createPostClientInstance(url) {
    this._clientPos = new ClientApi(url, this._apiKey, this._secret, this._deviceId);
    return this._clientPos;
  }

  getApi() {
    if (this._clientPos) {
      return this._clientPos;
    }
    return this.createPostClientInstance(baseUrl);
  }
}

export default new Api();
